export interface PublicTelecast {
  id: string;
  title: string;
  description: string | null;
  stream_url: string | null;
  thumbnail_url: string | null;
  source_type: "from_mjrc" | "from_outside";
  event_date: string | null;
  is_live: boolean;
  created_at: string | null;
}

interface TelecastRecord {
  id: string | number;
  title: string;
  description?: string | null;
  stream_url?: string | null;
  thumbnail_url?: string | null;
  thumbnail?: string | null;
  source_type?: string;
  event_date?: string | null;
  is_live?: boolean;
  is_published: boolean;
  created_at?: string | null;
}

const baseUrl = import.meta.env.DEV
  ? "/jambushrusti-api"
  : (
      import.meta.env.VITE_API_BASE_URL ||
      "https://api.jambushusti.universal-software.in/api"
    ).replace(/\/$/, "");
const endpoint = `${baseUrl}/jambushrusti/cms/telecasts/`;

export async function fetchPublicTelecasts(
  signal?: AbortSignal
): Promise<PublicTelecast[]> {
  const telecasts: PublicTelecast[] = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const response = await fetch(`${endpoint}?page=${page}`, {
      signal,
      headers: {
        "X-Tenant-ID":
          import.meta.env.VITE_X_TENANTID ||
          "6cf833d7-bf6f-4688-9136-5674d8053b85",
      },
    });
    if (!response.ok) {
      throw new Error("Unable to load live telecasts. Please try again.");
    }
    const payload = await response.json();
    const data = payload.data ?? payload;
    const rows: TelecastRecord[] = Array.isArray(data) ? data : data.results;
    if (!Array.isArray(rows)) {
      throw new Error("The telecast response could not be read.");
    }

    for (const record of rows) {
      if (record.is_published === true) {
        telecasts.push({
          id: String(record.id),
          title: record.title || "Untitled",
          description: record.description || null,
          stream_url: record.stream_url || null,
          thumbnail_url: record.thumbnail || record.thumbnail_url || null,
          source_type:
            (record.source_type as "from_mjrc" | "from_outside") || "from_mjrc",
          event_date: record.event_date || null,
          is_live: Boolean(record.is_live),
          created_at: record.created_at || null,
        });
      }
    }
    hasNext = Boolean(data.links?.next ?? data.next);
    page += 1;
  }
  return telecasts;
}
